import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-nest-base">
                <div className="h-10 w-10 rounded-full border-2 border-nest-clay border-t-transparent animate-spin"></div>
            </div>
        );
    }
    if (!user) return <Navigate to="/" replace />;
    if (!user.onboarded) return <Navigate to="/onboarding" replace />;
    if (user.role === "resident" && user.approval_status === "pending" && !user.is_owner) {
        return <Navigate to="/pending-approval" replace />;
    }
    return children;
}

export function RoleRoute({ roles, children }) {
    const { user } = useAuth();
    if (!user) return <Navigate to="/" replace />;
    if (!roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
    return children;
}
